module.exports = __webpack_public_path__ + "Graphik-Medium.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/fonts/Graphik-Medium.woff
 ** module id = 194
 ** module chunks = 1
 **/